// import Vue from 'vue'
import SvgIcon from './svg-icon.vue'; // svg组件

export default {
  install: (Vue: any) => {
    Vue.component(SvgIcon.name, SvgIcon);
  }
};
